import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'

import { ActionButtonLook, ActionButtonVariant } from '../../components/ActionButton/styled'
import { Icons } from '../../components/Icon'
import { actions, selectors } from '../../redux'
import { NUMBER_OF_CHILDREN } from '../../types'
import { routesPath } from '../../router'

export const useDeclarationFormLayout = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const step = useSelector(selectors.declaration.step)
  const hasPreviousStep = useSelector(selectors.declaration.hasPreviousStep)

  return {
    banner: {
      title: t('declaration.form.banner.title'),
      headerFaqButton: {
        text: 'FAQ',
        variant: ActionButtonVariant.white,
        look: ActionButtonLook.outlined,
        onClick: () => {
          navigate(routesPath.faq)
        },
      },
      ...(hasPreviousStep && {
        headerButton: {
          text: t('declaration.form.banner.headerButton.text'),
          variant: ActionButtonVariant.white,
          look: ActionButtonLook.outlined,
          iconProps: {
            icon: Icons.arrowLeft,
          },
          onClick: () => {
            dispatch(actions.declaration.setPreviousStep())
          },
        },
      }),
    },
    stepper: {
      steps: [
        {
          name: t('declaration.form.stepper.step1'),
          icon: {
            icon: Icons.declarant,
          },
          active: step < 5,
          completed: step >= 5,
        },
        {
          name: t('declaration.form.stepper.step2'),
          icon: {
            icon: Icons.conjoint,
          },
          active: step >= 5 && step < 8,
          completed: step >= 8,
        },
        {
          name: t('declaration.form.stepper.step3'),
          icon: {
            icon: Icons.enfant,
          },
          active: step >= 8 && step < 8 + NUMBER_OF_CHILDREN + 1,
          completed: step >= 8 + NUMBER_OF_CHILDREN + 1,
        },
      ],
    },
  }
}
